import { Outlet, Navigate, useLocation } from "react-router-dom";
import useAuth from "../Hooks/useAuth";

const PrivateRoute = ({ allowedRole }) => {
  let { auth } = useAuth();
  const location = useLocation();

  return (
    // it checks if the role present in auth matches or not
    allowedRole.includes(auth?.user?.roles) ? (
      <Outlet />
    ) : auth?.accessToken ? (
      <Navigate to="/unauthorized" state={{ from: location }} replace />
    ) : (
      <Navigate to="/login" state={{ from: location }} replace />
    )
  );
};

export default PrivateRoute;